// Schema di un flow_outcome: esito presentato a fine encounter
// in base a captured_data + flag_events.
import { z } from 'zod';
// Sprint 2: condizioni semplici (AND piatto di clausole campo == valore o flag presente).
// Sprint 6: builder visuale con AND/OR annidati + 3 nuovi leaf type
// (captured_compare, language_is, emotional_state_is).
// I nomi `captured_eq` / `captured_contains` sono mantenuti per compatibilità
// con i template seed esistenti.
export const ConditionClauseSchema = z.object({
    // Tipo: confronto su un campo catturato o presenza di un flag
    type: z.enum([
        'captured_eq',
        'captured_contains',
        'flag_present',
        'captured_compare',
        'language_is',
        'emotional_state_is',
    ]),
    // Per captured_*: il data_semantic della domanda da confrontare
    field: z.string().max(120).optional(),
    // Per captured_eq, captured_compare: il valore atteso
    value: z.union([z.string(), z.number(), z.boolean()]).optional(),
    // Per captured_contains: lista di valori (qualunque match passa)
    values: z.array(z.union([z.string(), z.number(), z.boolean()])).optional(),
    // Per flag_present: nome del flag
    flag: z.string().max(80).optional(),
    // Per flag_present: severity opzionale (info|warning|critical)
    severity: z.enum(['info', 'warning', 'critical']).optional(),
    // Per captured_compare: operatore numerico
    op: z.enum(['lt', 'lte', 'gt', 'gte', 'eq', 'neq']).optional(),
    // Per language_is: codice lingua (es. "it", "en", "ar")
    code: z.string().max(8).optional(),
    // Per emotional_state_is: stato emotivo (es. "spaventato", "calmo")
    state: z.string().max(40).optional(),
});
export const ConditionsSchema = z.lazy(() => z.object({
    op: z.enum(['AND', 'OR']),
    rules: z.array(z.union([ConditionClauseSchema, ConditionsSchema])).max(50),
}));
export const OutcomeActionSchema = z.object({
    type: z.enum(['info', 'redirect', 'resource_list']),
    content: z.string().max(2000).default(''),
    // Per redirect: URL. Per resource_list: array di oggetti {label, url}.
    meta: z.unknown().nullable().default(null),
});
export const FlowOutcomeSchema = z.object({
    id: z.string().uuid(),
    flow_id: z.string().uuid(),
    sort_order: z.number().int().min(0),
    name: z.string().min(1).max(120),
    description: z.string().max(500).default(''),
    conditions: ConditionsSchema.default({ op: 'AND', rules: [] }),
    action: OutcomeActionSchema,
    // Numero più basso = priorità più alta
    priority: z.number().int().min(0).max(1000).default(100),
});
export const FlowOutcomeCreateSchema = FlowOutcomeSchema.omit({
    id: true,
    flow_id: true,
});
export const FlowOutcomeUpdateSchema = FlowOutcomeCreateSchema.partial();
//# sourceMappingURL=flow-outcome.js.map